import React from 'react'
import { Field } from 'formik'
import { CustomTextField } from '../../components'
import { dataStreamURIValidate } from '../CreateDataChartForm/validation'

interface IDatastreamGraphicURLFormFragment {
  index: number
  disabled: boolean
  allowedDomains: string[]
}

export const DatastreamGraphicURLFormFragment = ({
  index,
  disabled,
  allowedDomains,
}: IDatastreamGraphicURLFormFragment) => (
  <Field
    name={`editions.${index}.dataStreamURI`}
    label="Linked graphic url"
    placeholder="Paste URL"
    component={CustomTextField}
    validate={dataStreamURIValidate(allowedDomains)}
    disabled={disabled}
  />
)
